import { defineFcm } from '../shared/factory';

export const FCM_ENFORCE_SECURE_IDENTIFIED_STATE = defineFcm('enforce_secure_identified_state')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'monorail',
		context: 'Signatures',
		description:
			'This flag prevents guest users from signing unless authenticated if they match an existing user. It does not affect who can read signed or started petition lists: that is controlled by allow_identified_user_fetch_petition_lists.',
	});
